import React, { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [hovering, setHovering] = useState(false);
  const [moved, setMoved] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 250, damping: 25 });
  const ringY = useSpring(y, { stiffness: 250, damping: 25 });

  const isTouch = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(hover: none)").matches;

  useEffect(() => {
    if (isTouch) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setMoved(true);
    };
    const over = (e) => {
      const el = e.target;
      setHovering(!!el.closest("a, button, [data-cursor='hover'], input, textarea, select"));
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y, isTouch]);

  // Do not render anything until the mouse actually moves (prevents off-screen
  // elements from causing horizontal overflow, and keeps it off on touch devices).
  if (isTouch || !moved) return null;

  return (
    <>
      <motion.div className="cursor-dot" style={{ x, y, translateX: "-50%", translateY: "-50%" }} />
      <motion.div
        className="cursor-ring"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={{ scale: hovering ? 1.8 : 1, opacity: hovering ? 0.6 : 1 }}
        transition={{ type: "spring", stiffness: 250, damping: 20 }}
      />
    </>
  );
}
